import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {OuterPagesGuardService} from '../../../guards/outer-pages-guard.service';
import {BlogsComponent} from './blogs.component';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.landingBlog.pageInRouting,
    data: {data: PAGES_AND_PATHS.landingBlog},
    component: BlogsComponent,
    canActivate: [OuterPagesGuardService],
    loadChildren: () => import('./blogs.module').then(m => m.BlogsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BlogsRoutingModule { }
